import { getSectionHeadingPath } from '@utils/apiFunctions';
import httpClient from '@utils/httpClient';
import { pathTypes } from '@utils/sectionEnums';

export function fetchPodcastItemsApiCall(blockId) {
  return httpClient.get(`api/podcast-blocks/${blockId}/items`);
}

export function sortPodcastItemsApiCall(blockId, items) {
  return httpClient.put(`api/podcast-blocks/${blockId}/items/sort`, { items });
}

export function fetchPodcastAlbumsApiCall(blockId) {
  return httpClient.get(`api/podcast-blocks/${blockId}/albums`);
}

// payload: { Title, Image, Description, Category, Slug, RssUrl, Links } (Links = JSON string)
export function createPodcastAlbumApiCall(blockId, payload) {
  return httpClient.post(`api/podcast-blocks/${blockId}/albums`, payload);
}

export function updatePodcastAlbumApiCall(blockId, albumId, payload) {
  return httpClient.put(`api/podcast-blocks/${blockId}/albums/${albumId}`, payload);
}

// Imports episodes from a podcast RSS feed. albumId=null → Core creates a new show from feed metadata.
export function importPodcastFeedApiCall(blockId, feedUrl, albumId = null) {
  return httpClient.post(`api/podcast-blocks/${blockId}/import-feed`, { FeedUrl: feedUrl, AlbumId: albumId });
}

export function deletePodcastAlbumApiCall(blockId, albumId) {
  return httpClient.delete(`api/podcast-blocks/${blockId}/albums/${albumId}`);
}

export function updatePodcastApiCall({
  id,
  isPathDesign,
  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,
  containerDesign,
  itemDesign,
  buttonDesign,
  view,
  layout,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.podcast, isPathDesign, id), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
    containerDesign,
    itemDesign,
    buttonDesign,
    view,
    layout,
  });
}
